import { CellContext } from '@tanstack/react-table'

import { DepositTransactionResponse } from '../../../../types'
import BankInfoCell from '../../../BankInfoCell'

type DepositData = DepositTransactionResponse['data'][number]

type PlayerBankInfoCellProps = {
	row: CellContext<DepositData, unknown>['row']
}

export default function PlayerBankInfoCell({ row }: PlayerBankInfoCellProps) {
	return (
		<BankInfoCell
			bank={row.original.playerBank}
			displayText={row.original.playerBankInfo || '-'}
		/>
	)
}
